// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CommonsService {

  apiUrl: string;

  companiesSelected: any[];
  companiesSelectedChange: Subject<any[]> = new Subject<any[]>();

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;

    this.companiesSelectedChange.subscribe((companies) => {
      this.companiesSelected = companies;
    });
  }

  changeCompaniesSelected(companies: any[]): void {
    this.companiesSelectedChange.next(companies);
  }

  searchTransactions (
    companies: string[],
    nifs: string[]
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let companyStr = '';
    let nifsStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(nifs) && nifs.length > 0) {
      nifs.some((nif, i) => {
        nifsStr = nifsStr.concat('nifs=' + nif);
        nifsStr = i + 1 < nifs.length ? nifsStr.concat('&') : nifsStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra-cit/overview?${companyStr}&${nifsStr}`;
    return this.http.get( requesttUrl, { headers } )
      .pipe(
          map((res: Response) => res),
          catchError(err => { console.error('Error: ' + err.error.code + ': ' + err.error.message + ' (' +  err.status + ': ' + err.statusText  + ')' ); return err; })
      );
  }

  queryStringify(query): string {
    let str = '{';
    for (const item of query) {
      if (item.param) {
        str = str.concat('"').concat(item.param).concat('": ');
        if (typeof item.value === 'string') {
          str = str.concat('"').concat(item.value).concat('"');
        } else {
          if (Array.isArray(item.value)) {
            str = str.concat('[');
            for (const i of item.value) {
              str = str.concat(i);
              if (item.value.indexOf(i) < item.value.length - 1) {
                str = str.concat(',');
              }
            }
            str = str.concat(']');

          } else {
            str = str.concat(item.value);
          }
        }
      }
      if (query.indexOf(item) < query.length - 1 && query.length > 1) {
        str = str.concat(', ');
      }
    }
    str = str.concat('}');
    return str;
  }


  isInArray(array, item, param): boolean {
    for (const i of array) {
      if (i[param] === item[param]) {
        return true;
      }
    }
    return false;
  }

  getIndexOnArray(array, item, param): number {
    let index = 0;
    for (let i = 0; i < array.length; i ++) {
      if (array[i][param] === item[param]) {
        index = i;
      }
    }
    return index;
  }

  sortArray(arr, key): any {
    return arr.sort((a, b) => {
      const keyA = a[key];
      const keyB = b[key];
      if (keyA < keyB) { return -1; } else if (keyA > keyB) { return 1; }
      return 0;
    });
  }

}
